module.exports = __webpack_public_path__ + "static/img/lg-ess-thumb.41fd5b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/pjmove-thumbs/lg-ess-thumb.jpg
// module id = SMRJ
// module chunks = 0